import { render, staticRenderFns } from "./ThgContactData.vue?vue&type=template&id=20172484"
import script from "./ThgContactData.vue?vue&type=script&lang=ts"
export * from "./ThgContactData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports